module.exports = __webpack_public_path__ + "img/hybrid1.a255559d.jpg";